<template>
  <div class="m-homepage-visualization__menu">
    <div class="a-homepage-visualization__menu-item">
      {{ viewLabel }}
    </div>

    <h3 id="menu-description" class="visually-hidden">
      {{ overviewDescription }}
    </h3>

    <ul aria-labelledby="menu-description" role="tablist">
      <li
        v-for="datum in dataset"
        :key="datum.id"
        class="a-homepage-visualization__menu-item"
        :class="{
          'a-homepage-visualization__menu-item--selected':
            datum.id === selectedViewId
        }"
        :aria-selected="datum.id === selectedViewId"
        :aria-controls="datum.id + '_tab'"
        :tabindex="0"
        role="tab"
        @click="setSelectedViewId(datum.id, selectedViewId)"
        @keypress.enter="setSelectedViewId(datum.id, selectedViewId)"
      >
        {{ $t(`overview.${datum.id}`) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OverviewMenu",
  props: {
    /**
     * Id of the current menu item
     *
     * @type {String}
     */
    selectedViewId: { type: String, required: true },
    /**
     * Array of objects containing the view id and the view content information
     *
     * @type {Array}
     */
    dataset: { type: Array, required: true }
  },
  emits: ["menuViewClick"],
  data() {
    return {
      viewLabel: this.$t("overview.viewLabel"),
      overviewDescription: this.$t("overview.overviewDescription")
    };
  },
  methods: {
    /**
     * Everytime the user clicks on a menu item, the menuViewClick event is emitted
     * @param {String} viewId id of the clicked menu item
     * @param {String} currentId id of the current menu item
     */
    setSelectedViewId(viewId, currentId) {
      this.$emit("menuViewClick", viewId, currentId);
    }
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
